export default {"src":"https://web.cdn.greenlight.com/2.1283.0/_next/static/media/plus-white.1b8bea56.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};